import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";

/****************fetch interested */
const fetchInterested = async (data) => {
  const orderByParam =
    data?.orderBy !== undefined ? `OrderBy=${data?.orderBy}` : "FirstName";
  const orderDirParam =
    data?.orderDir !== undefined ? `orderDir=${data?.orderDir}` : "asc";
  const fieldOfInterestParam =
    data?.FieldOfInterest !== undefined
      ? `FieldOfInterest=${data?.FieldOfInterest}`
      : "";
  const statusParam =
    data?.status !== undefined ? `status=${data?.status}` : "";
  const programParam =
    data?.program !== undefined ? `program=${data?.program}` : "";
  const searchParam =
    data?.search !== undefined ? `SearchBy=${data?.search}` : "";

  return await axios.get(
    API_URL +
      `/api/ApplicantView/GetShowingInterest/${data?.pageSize}/${data?.pageNumber}?${orderByParam}&${orderDirParam}&${fieldOfInterestParam}&${statusParam}&${programParam}&${searchParam}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchInterested = (data) => {
  return useQuery({
    queryKey: ["Interested"],
    queryFn: () => fetchInterested(data),
    enabled: true,
  });
};

/****************fetch single interested */

const fetchSingleInterested = async (id) => {
  if (id) {
    return await axios.get(
      API_URL + `/api/ApplicantView/GetIntrestedById?ShowingInterestId=${id}`,
      {
        headers: securityHeaders,
      }
    );
  }
};
export const useFetchSingleInterested = (id) => {
  return useQuery({
    queryKey: ["InterestedbyId"],
    queryFn: () => fetchSingleInterested(id),
    enabled: true,
  });
};

/*******************Get applicant status */
const fetchInterestedStatus = async () => {
  return await axios.get(API_URL + "/api/ApplicantView/GetIntrestedStatuses", {
    headers: securityHeaders,
  });
};
export const useFetchInterestedStatus = () => {
  return useQuery({
    queryKey: ["interestedtStatus"],
    queryFn: () => fetchInterestedStatus(),
    enabled: true,
  });
};

/***********Export table */
const exportShowingInterest = async () => {
  return await axios.get(API_URL + "/api/Export/ExportShowingInterest", {
    headers: securityHeaders,
    responseType: "blob",
  });
};
export const useExportShowingInterestTable = () => {
  return useMutation(() => exportShowingInterest());
};
